import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-05819de0")
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "slide-container" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = {
  key: 0,
  class: "out-time"
}
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "bottom-info" }
const _hoisted_7 = { class: "right" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 图片教学 ")
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 视频教学 ")
const _hoisted_12 = {
  key: 0,
  class: "info-text"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "line-cup" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "left-cup" }),
  /*#__PURE__*/_createElementVNode("div", { class: "lines" }),
  /*#__PURE__*/_createElementVNode("div", { class: "right-cup" })
], -1)
const _hoisted_14 = { class: "bottom-menu" }
const _hoisted_15 = {
  key: 1,
  class: "cup"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "cup" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", {
    class: "slide-item",
    id: _ctx.datas.id
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "item-title",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShowDetail(_ctx.datas)))
      }, [
        _createElementVNode("span", null, "操作开始时间：" + _toDisplayString(_ctx.datas.optionTime), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass('operation-' + _ctx.datas.status)
          }, null, 2),
          (_ctx.datas.outTime > 0 && _ctx.datas.status == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 逾期" + _toDisplayString(_ctx.datas.outTime) + "天 ", 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: "product-item",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onShowDetail(_ctx.datas)))
      }, [
        _createVNode(_component_van_image, {
          radius: "10px",
          class: "left",
          src: _ctx.datas.typeImg + '?imageView2/1/w/100/h/100/rotate/0',
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.preview(_ctx.datas.typeImg ? _ctx.datas.typeImg : undefined)), ["stop"]))
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, _toDisplayString(_ctx.datas.typeName || "无"), 1),
          _createElementVNode("div", null, [
            _createElementVNode("span", null, "地块编码：" + _toDisplayString(_ctx.datas.areaCode || "无"), 1),
            _createElementVNode("span", null, "种植面积：" + _toDisplayString(_ctx.datas.areaArea || "0") + "亩", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "phenodate",
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.onShowDetail(_ctx.datas)), ["stop"]))
      }, [
        _createVNode(_component_van_image, {
          radius: "5px",
          class: "left",
          src: 
            _ctx.datas.plantFarmingImg && _ctx.datas.plantFarmingImg.split(',').length > 0
              ? _ctx.datas.plantFarmingImg.split(',')[0] +
                '?imageView2/1/w/200/h/200/rotate/0'
              : ''
          ,
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
            _ctx.preview(
              _ctx.datas.plantFarmingImg &&
                _ctx.datas.plantFarmingImg.split(',').length > 0
                ? _ctx.datas.plantFarmingImg.split(',')[0] +
                    '?imageView2/1/w/200/h/200/rotate/0'
                : ''
            )
          ), ["stop"]))
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, _toDisplayString(_ctx.datas.plantFarmingName || "无"), 1),
          _createElementVNode("div", null, "物候期：" + _toDisplayString(_ctx.datas.phaseName || "无"), 1),
          _createElementVNode("div", null, "预计人工：" + _toDisplayString(_ctx.datas.plantFarmingArtificial || "0") + "人工/亩", 1),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_van_image, {
                class: "img",
                src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/tupian-bg.png"
              }),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_van_image, {
                class: "img",
                src: "https://qnui.xfarmer.com/xfarmer-ui/h5Home/shipin-bg.png"
              }),
              _hoisted_11
            ])
          ])
        ])
      ]),
      (_ctx.item.plantFarmingInfo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.item.plantFarmingInfo), 1))
        : _createCommentVNode("", true)
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      (_ctx.datas.status == 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onIgnore(_ctx.datas)))
          }, "忽略"))
        : _createCommentVNode("", true),
      (_ctx.datas.status == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.onShowDetail(_ctx.datas)), ["prevent"]))
      }, "查看详情"),
      _hoisted_16,
      _createElementVNode("div", {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onRecord(_ctx.datas)))
      }, "记录成果")
    ])
  ], 8, _hoisted_1))
}